import React, { useEffect, useState } from "react";
import Sidebar from "../../../layout/Sidebar";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import { planListColumns } from "../../../tables/planListColumns";
import AdminDataTable from "../../../components/common/AdminDataTable";
import { useNavigate } from "react-router-dom";
import { can } from "../../../utils/can";

export default function ViewPlan() {
  const PAGE_SIZE = 10;
      const [sortBy, setSortBy] = useState("createdAt");
      const [sortOrder, setSortOrder] = useState("desc");
      const [pageSize, setPageSize] = useState(PAGE_SIZE);
      const [page, setPage] = useState(1);
      const [totalPages, setTotalPages] = useState(1);
      const [listLoading, setListLoading] = useState(false);
      const token = localStorage.getItem("adminToken");
      const [plan, setPlan] = useState([]);
      const navigate = useNavigate();
      const API_URL = process.env.REACT_APP_BASE_URL_API || "";

       const fetchPlan = async (pageNumber = 1) => {
        setListLoading(true);
        try {
            const url = `${API_URL}/api/admin/membership-plan?page=${pageNumber}&limit=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`;

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            if (!response.ok) {
                throw new Error("Failed to fetch plan");
            }

            const data = await response.json();
            setPlan(data.data);
            setTotalPages(Math.ceil(data.totalCount / pageSize));

            setListLoading(false);
        } catch (error) {
            console.error("Error fetching plan:", error);
            setListLoading(false);
        }
    };
    const handleEdit = (id) => {
      if(can("view_plan", "edit") === false){
        alert("You don't have permission to edit plans.");
        return;
      }
      
        window.location.href = `/admin/membership/edit-plan/${id}`;
    };

    const handleDelete = (id) => {
        // Handle delete action
    };

    const columns = planListColumns({ handleEdit, handleDelete, PAGE_SIZE });
    
        useEffect(() => {
            fetchPlan(page);
        }, [page, sortBy, sortOrder, pageSize]);

  return (
    <div class="container body">
      <div class="main_container">
        <Sidebar />
        <Header pageTitle="View Plan" />
        {/* page */}
        <div className="right_col" role="main">
        
        
          {/* /top tiles */}
          {/* body card start */}
          <div className="x_panel">
            <div className="x_title">
              <h2>Plan List</h2>
              <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                <li>
                  <a className="collapse-link">
                    <i className="fa fa-chevron-up" />
                  </a>
                </li>

              </ul>
              <div className="clearfix" />
            </div>
            
               <AdminDataTable
                  columns={columns}
                  data={plan}
                  loading={listLoading}
                  page={page}
                  totalPages={totalPages}
                  onPageChange={setPage}
              />

          </div>
          {/* bod card end */}
        </div>

        {/* page end */}
        <Footer />

      </div>
    </div>
  );
}